import Typography from '@components/Typography';

import { PROMOTION_TYPES } from './common';
import { Description, NoteWrapper, Title } from './styled';
type Props = {
  promotions: any;

  promotion: string;
};

const ModalFooterTurkTelekom = ({ promotions, promotion }: Props) => {
  return (
    <>
      {promotion === PROMOTION_TYPES.TTPRIME ? (
        <NoteWrapper>
          <Typography variant='caption1' weight='SemiBold' color='D400'>
            <Title>{promotions.prime.promotionTitle}</Title>
          </Typography>
          <Typography variant='caption2' weight='Regular' color='D400'>
            <Description>{promotions.prime.promotionDescription}</Description>
          </Typography>
        </NoteWrapper>
      ) : null}
      {promotion === PROMOTION_TYPES.TURKTELEKOM ? (
        <NoteWrapper>
          <Typography variant='caption1' weight='SemiBold' color='D400'>
            <Title>{promotions.turktelekom.promotionTitle}</Title>
          </Typography>
          <Typography variant='caption2' weight='Regular' color='D400'>
            <Description>
              {promotions.turktelekom.promotionDescription}
            </Description>
          </Typography>
        </NoteWrapper>
      ) : null}
      {promotion === PROMOTION_TYPES.TTBUSINESS ? (
        <NoteWrapper>
          <Typography variant='caption1' weight='SemiBold' color='D400'>
            <Title>{promotions.business.promotionTitle}</Title>
          </Typography>
          <Typography variant='caption2' weight='Regular' color='D400'>
            <Description>
              {promotions.business.promotionDescription}
            </Description>
          </Typography>
        </NoteWrapper>
      ) : null}
    </>
  );
};

export default ModalFooterTurkTelekom;
